import { Component, inject } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { ModalService } from 'apps/lghf/src/app/services/modal.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-lib-ff-repeat',
  styleUrls: ['repeat.component.scss'],
  templateUrl: 'repeat.component.html',
  imports: [FormlyModule, NgTemplateOutlet],
})
export class FormlyRepeatComponent extends FieldArrayType {
  private readonly modalService = inject(ModalService);

  private modalRef: NgbModalRef;

  public openTooltip() {
    this.modalRef = this.modalService.open(this.props.tooltip, {
      props: {
        title: this.props.addText,
      },
    });
  }

  public close() {
    this.modalRef.close();
  }
}
